import { css } from '@linaria/core';
import { breakpoints } from 'styles/utils';
export const navTabsWrapper = "odules__Featured__components__NavTabs__styles_ts-navTabsWrapper-n103izo7";
export const navTabsList = "odules__Featured__components__NavTabs__styles_ts-navTabsList-n3kjgdv";
export const navTab = "odules__Featured__components__NavTabs__styles_ts-navTab-npy75qy";

require("./styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");